var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlockMarginMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.25;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,14H3c-0.8,0-1.5-0.7-1.5-1.5S2.2,11,3,11h18c0.8,0,1.5,0.7,1.5,1.5S21.8,14,21,14z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,22.5H3c-0.8,0-1.5-0.7-1.5-1.5v-3.5C1.5,16.7,2.2,16,3,16h18c0.8,0,1.5,0.7,1.5,1.5V21 C22.5,21.8,21.8,22.5,21,22.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockMarginMd);
export default __webpack_public_path__ + "static/media/icon-block-margin-md.cd4c6e248fa43672ba549bd40a1797dc.svg";
export { ForwardRef as ReactComponent };